import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "camera"
const CameraIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 8.25C14.485 8.25 16.5 10.265 16.5 12.75S14.485 17.25 12 17.25 7.5 15.235 7.5 12.75 9.515 8.25 12 8.25M12 9.75C10.343 9.75 9 11.093 9 12.75S10.343 15.75 12 15.75 15 14.407 15 12.75 13.657 9.75 12 9.75"
            clipRule="evenodd"
          />
          <path d="M5.625 8.25C6.246 8.25 6.75 8.754 6.75 9.375S6.246 10.5 5.625 10.5 4.5 9.996 4.5 9.375 5.004 8.25 5.625 8.25" />
          <path
            fillRule="evenodd"
            d="M12 2.25C15 2.25 15.75 3 15.75 3L17.25 5.25H21C21.828 5.25 22.5 5.922 22.5 6.75V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V6.75C1.5 5.922 2.172 5.25 3 5.25H6.75L8.25 3S9 2.25 12 2.25M12 3.75C10.62 3.75 9.85 3.923 9.475 4.048Q9.376 4.081 9.313 4.108L7.553 6.75H3V18.75H21V6.75H16.447L14.686 4.107Q14.623 4.081 14.526 4.048C14.15 3.923 13.378 3.75 12 3.75"
            clipRule="evenodd"
          />
          <path d="M21.75 2.25C21.75 3.078 21.078 3.75 20.25 3.75H18V2.25z" />
        </svg>
      }
    </span>
  )
}
export default CameraIcon
